import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { WarehouseOrderRate, WarehouseOrderRateDataForm, WarehouseOrderRateFilters } from '../../../../app/models/WareHouseOrderRates';
import useWarehouseOrderRatesService from '../../../../app/services/hooks/useWareHouseOrderRateService';
import { AppContext } from '../../../../contexts/AppContext';
import DefaultCard from '../../../../components/default/DefaultCard';
import WarehouseRatesDataTable from '../../../Quotes/subpages/WareHouseQuote/components/tables/WarehouseQuoteRateDataTable';
import { WarehouseQuoteRate } from '../../../../app/models/WareHouseQuoteRates';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import DefaultModal from '../../../../components/default/DefaultModal';
import WarehouseQuoteRateShow from '../../../Quotes/subpages/WareHouseQuote/components/WarehouseRateShow';
import WarehouseOrderRateShow from '../WarehouseOrderRateShow';

interface Props {
    warehouseOrderId: number;
    disableUpdate?: boolean;
    isFormShow?: boolean;
    refresh?: number;
    rates?: WarehouseOrderRateDataForm;
}

const WarehouseOrderRatesContainer = ({ 
    warehouseOrderId,
    disableUpdate = false,
    isFormShow = false,
    refresh,
    rates
}: Props) => {
    const {
        getAllWarehouseOrderRatesByOrder,
        fetchingGetWarehouseOrderRates
    } = useWarehouseOrderRatesService();

    const [warehouseOrderRates, setWarehouseOrderRates] = useState<WarehouseOrderRate[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseOrderRateFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [warehouseRateIdEdit, setWarehouseRateIdEdit] = useState<number>(-1);
    const [rateIdEdit, setRateIdEdit] = useState<number>(-1);
    const [rateIdShow, setRateIdShow] = useState<number>(-1);

    useEffect(() => {
        if (warehouseOrderId) reloadTable();
    }, [warehouseOrderId, filter, refresh]);

    const reloadTable = () => {
        getAllWarehouseOrderRatesByOrder(warehouseOrderId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseOrderRates(response.data.warehouse_order_rates);
                setTotalRows(response.data.total_rows);
            }
        });
    };

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setWarehouseRateIdEdit(id);
    };
    const showShow = (id: number) => {
        setShowingShow(true);
        setRateIdShow(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setWarehouseRateIdEdit(-1);
    };

    const hideShow = () => {
        setShowingShow(false);
        setRateIdShow(-1);
    };

   
    return (
        <>

            <DefaultCard>
                <div className="h3 mt-0 mb-4 card-title">Tarifas</div> 
                <div className="row">
                    <div className="col-12">
                        <WarehouseRatesDataTable
                            warehouseQuoteRates={warehouseOrderRates}
                            totalRows={totalRows}
                            loading={fetchingGetWarehouseOrderRates}
                            show={showShow}
                            // edit={showEdit}
                            // destroy={destroy}
                            filter={filter}
                            setFilter={setFilter}
                            isShow={isFormShow}

                        />
                    </div>
                </div>
            </DefaultCard>
            {showingShow ?(
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver Tarifa"
                showFooter={false}
            >
                <WarehouseOrderRateShow 
                rateId={rateIdShow}
                onCancel={hideShow}

                 />
            </DefaultModal>
                    ) : null}
        </>
    );
};

export default WarehouseOrderRatesContainer;
